export const _ADD       = "hawU+gAS+buHMF1Ny5sRgg==";
export const _EDIT      = "N2bDI6xFZzgySDb4osMflw==";
export const _VIEW      = "7czge+3YJMhhvemtoGcC4w==";
export const _DELETE    = "Ia+jVw+ZejPuvkT6gvnfvQ==";
export const _RECOVER   = "UPkRlqMCUmkLAhRPdee4OA==";
export const _LIST      = "gEdCSxFfxQuWuUxpUy4GXw==";
export const _TRASH     = "D4JWb6Xxy2Rkdgysp6EzZg==";